let local = null;

try {
  let local = localStorage.getItem('userSettings')
  local = JSON.parse(local)
  
}
catch(e) {}

const state = {

  gameMode: (local && local.gameMode) ? local.gameMode : 'quick',

  selectedTheme: (local && local.selectedTheme) ? local.selectedTheme : 'standard',

  showTimer: (local && local.showTimer) ? local.showTimer : true,

  allowHints: (local && local.allowHints) ? local.allowHints : true,

  visualGuides: (local && local.visualGuides) ? local.visualGuides : true,

  crosswordJumpToBlank: (local && local.crosswordJumpToBlank) ? local.crosswordJumpToBlank : false,

//crossWordInputMode
  
  themes: {
    'standard': {display: '#fff'},
    // 'ocean': {display: '#5ca2a5'},
    // 'colourful': {display: '#e8b99b'},
    // 'harmonious': {display: '#cba4aa'},
    'candlelight': {display: '#e4d3c1'},
    'night': {display: '#252525'},
  },
}

const getters = {
}

const actions = {
  selectTheme({ commit, dispatch }, theme) {
    commit('SELECT_THEME', theme)
    dispatch('setLocalUserSettings')
  },

  selectThemeFromLocal({ commit, rootState }) {
    let local = localStorage.getItem(rootState.game.type+'userSettings')
    local = JSON.parse(local)

    if (local && local.selectedTheme)
      commit('SELECT_THEME', local.selectedTheme)    
  },

  setGameMode({ commit, dispatch }, gameMode) {
    commit('SET_GAME_MODE', gameMode)
    dispatch('setLocalUserSettings')
  },

  getLocalUserSettings({ commit, rootState }) {
    if (!rootState.game.type) return
    let local = localStorage.getItem(rootState.game.type+'-userSettings')
    if (!local) return
    commit('SET_USER_SETTINGS', local)
  },

  setLocalUserSettings({ state, rootState }) {
    if (!rootState.game.type) return
    localStorage.setItem(rootState.game.type+'-userSettings', JSON.stringify(state))
  },

  setShowTimer({ commit, dispatch }, bool) { 
    commit('SET_SHOW_TIMER', bool)
    dispatch('setLocalUserSettings')
  },

  setAllowHints({ commit, dispatch }, bool) {   
    commit('SET_ALLOW_HINTS', bool)
    dispatch('setLocalUserSettings')
  },

  setVisualGuides({ commit, dispatch }, bool) {   
    commit('SET_VISUAL_GUIDES', bool)
    dispatch('setLocalUserSettings')
  },

  setCrosswordJumpToBlank({ commit, dispatch }, bool){
    commit('SET_CROSSWORD_JUMP_TO_BLANK', bool)
    dispatch('setLocalUserSettings')
  },

  setStateSettingsToLocal({ rootState, dispatch }){
    let local = localStorage.getItem(rootState.game.type+'-userSettings')
    const jsonObject = JSON.parse(local);
    const crosswordJumpToBlank = jsonObject.crosswordJumpToBlank;
    const showTimer = jsonObject.showTimer;
    const visualGuides = jsonObject.visualGuides;
    const allowHints = jsonObject.allowHints;

    dispatch('setCrosswordJumpToBlank', crosswordJumpToBlank)
    dispatch('setShowTimer', showTimer)
    dispatch('setVisualGuides', visualGuides)
    dispatch('setAllowHints', allowHints)
  },

  getCrosswordJumpToBlank({ rootState, dispatch }){
    let local = localStorage.getItem(rootState.game.type+'-userSettings')
    const jsonObject = JSON.parse(local);
    const crosswordJumpToBlank = jsonObject.crosswordJumpToBlank;

    dispatch('setCrosswordJumpToBlank', crosswordJumpToBlank)

  },

  getShowTimer({ rootState, dispatch }){
    let local = localStorage.getItem(rootState.game.type+'-userSettings')
    const jsonObject = JSON.parse(local);
    const setting = jsonObject.showTimer;

    dispatch('setShowTimer', setting)
  },

}

const mutations = {
  SET_USER_SETTINGS(state, userSettings) {
    state = userSettings
    document.body.classList.add(`theme-${ theme }`)
  },
  
  SELECT_THEME(state, theme) {
    state.selectedTheme = theme

    let app = document.getElementById('puzzleapp')

    // this probs sould be in the game view
    for (let theme in state.themes)
      app.classList.remove(`theme-${ theme }`)

    app.classList.add(`theme-${ theme }`)
  },
  
  // string,: quick, challenge
  SET_GAME_MODE(state, gameMode) {
    state.gameMode = gameMode
  },

  // boolean
  SET_SHOW_TIMER(state, bool) {
    state.showTimer = bool
  },

  // boolean
  SET_ALLOW_HINTS(state, bool) {
    state.allowHints = bool
  },

  // boolean
  SET_VISUAL_GUIDES(state, bool) {
    state.visualGuides = bool
  },

  // boolean
  SET_CROSSWORD_JUMP_TO_BLANK(state, bool){
    
    state.crosswordJumpToBlank = bool
  }

}

export {
  state,
  getters,
  actions,
  mutations,
}